<div class="modal fade" id="kt_modal_bl_amend_form" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered modal-fullscreen">
    <div class="modal-content">
      <div class="modal-header p-3 d-flex justify-content-between bg-secondary">
        <h2 class="fw-bold m-0">BL Amendment Form - Stage {{ formStage }}</h2>
        <div class="btn btn-icon btn-sm btn-active-icon-primary" data-bs-dismiss="modal">
          <i class="ki-duotone ki-cross fs-1">
            <span class="path1"></span>
            <span class="path2"></span>
          </i>
        </div>
      </div>

      <div class="modal-body p-5">
        <!-- Car Details Section - Dynamic for all vehicles -->
        <div class="card mb-5" *ngIf="order?.vehicles?.length">
          <div class="card-header bg-light-primary">
            <h4 class="card-title m-0">Car Details</h4>
          </div>
          <div class="card-body p-3">
            <ng-container *ngFor="let vehicle of order.vehicles; let i = index">
              <div class="row mb-3" [class.border-top]="i > 0" [class.pt-3]="i > 0">
                <!-- <div class="col-12 mb-2" *ngIf="order.vehicles.length > 1">
                  <span class="badge badge-primary">Vehicle {{ i + 1 }}</span>
                </div> -->
                <!-- <div class="col-md-2"> -->
                  <!-- <img [src]="vehicle?.pictures?.[0] || 'assets/media/svg/files/blank-image.svg'"
                       class="img-fluid rounded" style="max-height: 100px; object-fit: cover;" alt="Vehicle"> -->
                <!-- </div> -->
                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-2">Vehicle {{ i + 1 }}</div>
                    <div class="col-md-2"><strong>Stock:</strong> {{ vehicle?.car_no || '-' }}</div>
                    <div class="col-md-2"><strong>Chassis:</strong> {{ vehicle?.vin_no || '-' }}</div>
                    <div class="col-md-3"><strong>Make:</strong> {{ vehicle?.maker_name || '-' }}</div>
                    <div class="col-md-3"><strong>Model:</strong> {{ vehicle?.name || '-' }}</div>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </div>

        <!-- BL Form Table -->
        <div class="table-responsive">
          <table class="table table-bordered table-row-bordered align-middle">
            <thead class="bg-light">
              <tr>
                <th class="min-w-150px">Field</th>
                <th class="min-w-200px">
                  Original Details
                  <div class="form-check mt-2">
                    <input class="form-check-input" type="checkbox" (change)="copyToAmendment(0)" id="copyOriginal" [disabled]="isFormDisabled(1)">
                    <label class="form-check-label" for="copyOriginal">Copy to Amendment 1</label>
                  </div>
                </th>
                <th class="min-w-200px">
                  BL Amendment 1
                  <div class="form-check mt-2">
                    <input class="form-check-input" type="checkbox" (change)="copyToAmendment(1)" id="copyAmend1" [disabled]="isFormDisabled(2)">
                    <label class="form-check-label" for="copyAmend1">Copy to Amendment 2</label>
                  </div>
                </th>
                <th class="min-w-200px">
                  BL Amendment 2
                  <div class="form-check mt-2">
                    <input class="form-check-input" type="checkbox" (change)="copyToAmendment(2)" id="copyAmend2" [disabled]="isFormDisabled(3)">
                    <label class="form-check-label" for="copyAmend2">Copy to Amendment 3</label>
                  </div>
                </th>
                <th class="min-w-200px">BL Amendment 3</th>
              </tr>
            </thead>
            <tbody>
              <!-- Shipper Section Header -->
              <tr class="bg-light-primary">
                <td><strong>Shipper Information</strong></td>
                <td>-</td>
                <td>
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" [(ngModel)]="sectionCheckboxes[1].shipper_information"
                           id="shipper_info_1" [disabled]="isFormDisabled(1)">
                    <label class="form-check-label" for="shipper_info_1">Include</label>
                  </div>
                </td>
                <td>
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" [(ngModel)]="sectionCheckboxes[2].shipper_information"
                           id="shipper_info_2" [disabled]="isFormDisabled(2)">
                    <label class="form-check-label" for="shipper_info_2">Include</label>
                  </div>
                </td>
                <td>
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" [(ngModel)]="sectionCheckboxes[3].shipper_information"
                           id="shipper_info_3" [disabled]="isFormDisabled(3)">
                    <label class="form-check-label" for="shipper_info_3">Include</label>
                  </div>
                </td>
              </tr>
              <ng-container *ngFor="let field of shipperFields">
                <tr>
                  <td><strong>{{ field.label }}</strong></td>
                  <td>{{ getOriginalValue(field.key) }}</td>
                  <td>
                    <input type="text" class="form-control form-control-sm"
                           [formControl]="getFormControl(blForm1, field.key)"
                           [disabled]="isFormDisabled(1)">
                  </td>
                  <td>
                    <input type="text" class="form-control form-control-sm"
                           [formControl]="getFormControl(blForm2, field.key)"
                           [disabled]="isFormDisabled(2)">
                  </td>
                  <td>
                    <input type="text" class="form-control form-control-sm"
                           [formControl]="getFormControl(blForm3, field.key)"
                           [disabled]="isFormDisabled(3)">
                  </td>
                </tr>
              </ng-container>

              <!-- Consignee Section Header -->
              <tr class="bg-light-primary">
                <td><strong>Consignee Information</strong></td>
                <td>-</td>
                <td>
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" [(ngModel)]="sectionCheckboxes[1].consignee_information"
                           id="consignee_info_1" [disabled]="isFormDisabled(1)">
                    <label class="form-check-label" for="consignee_info_1">Include</label>
                  </div>
                </td>
                <td>
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" [(ngModel)]="sectionCheckboxes[2].consignee_information"
                           id="consignee_info_2" [disabled]="isFormDisabled(2)">
                    <label class="form-check-label" for="consignee_info_2">Include</label>
                  </div>
                </td>
                <td>
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" [(ngModel)]="sectionCheckboxes[3].consignee_information"
                           id="consignee_info_3" [disabled]="isFormDisabled(3)">
                    <label class="form-check-label" for="consignee_info_3">Include</label>
                  </div>
                </td>
              </tr>
              <ng-container *ngFor="let field of consigneeFields">
                <tr>
                  <td><strong>{{ field.label }}</strong></td>
                  <td>{{ getOriginalValue(field.key) }}</td>
                  <td>
                    <input type="text" class="form-control form-control-sm"
                           [formControl]="getFormControl(blForm1, field.key)"
                           [disabled]="isFormDisabled(1)">
                  </td>
                  <td>
                    <input type="text" class="form-control form-control-sm"
                           [formControl]="getFormControl(blForm2, field.key)"
                           [disabled]="isFormDisabled(2)">
                  </td>
                  <td>
                    <input type="text" class="form-control form-control-sm"
                           [formControl]="getFormControl(blForm3, field.key)"
                           [disabled]="isFormDisabled(3)">
                  </td>
                </tr>
              </ng-container>

              <!-- Notify Party Section Header -->
              <tr class="bg-light-primary">
                <td><strong>Notify Party Information</strong></td>
                <td>-</td>
                <td>
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" [(ngModel)]="sectionCheckboxes[1].notify_party_information"
                           id="notify_party_info_1" [disabled]="isFormDisabled(1)">
                    <label class="form-check-label" for="notify_party_info_1">Include</label>
                  </div>
                </td>
                <td>
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" [(ngModel)]="sectionCheckboxes[2].notify_party_information"
                           id="notify_party_info_2" [disabled]="isFormDisabled(2)">
                    <label class="form-check-label" for="notify_party_info_2">Include</label>
                  </div>
                </td>
                <td>
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" [(ngModel)]="sectionCheckboxes[3].notify_party_information"
                           id="notify_party_info_3" [disabled]="isFormDisabled(3)">
                    <label class="form-check-label" for="notify_party_info_3">Include</label>
                  </div>
                </td>
              </tr>
              <ng-container *ngFor="let field of notifyPartyFields">
                <tr>
                  <td><strong>{{ field.label }}</strong></td>
                  <td>{{ getOriginalValue(field.key) }}</td>
                  <td>
                    <input type="text" class="form-control form-control-sm"
                           [formControl]="getFormControl(blForm1, field.key)"
                           [disabled]="isFormDisabled(1)">
                  </td>
                  <td>
                    <input type="text" class="form-control form-control-sm"
                           [formControl]="getFormControl(blForm2, field.key)"
                           [disabled]="isFormDisabled(2)">
                  </td>
                  <td>
                    <input type="text" class="form-control form-control-sm"
                           [formControl]="getFormControl(blForm3, field.key)"
                           [disabled]="isFormDisabled(3)">
                  </td>
                </tr>
              </ng-container>

              <!-- Vehicle Details Section - Dynamic for all vehicles -->
              <ng-container *ngFor="let vehicle of order?.vehicles; let vehicleIdx = index">
                <!-- Vehicle Details Section Header for each vehicle -->
                <tr class="bg-light-primary">
                  <td><strong>Vehicle Details {{ vehicleIdx + 1 }}</strong></td>
                  <td>-</td>
                  <td>
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox" [(ngModel)]="sectionCheckboxes[1]['vehicle_' + vehicleIdx + '_include']"
                             [id]="'vehicle_' + vehicleIdx + '_include_1'" [disabled]="isFormDisabled(1)">
                      <label class="form-check-label" [for]="'vehicle_' + vehicleIdx + '_include_1'">Include</label>
                    </div>
                  </td>
                  <td>
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox" [(ngModel)]="sectionCheckboxes[2]['vehicle_' + vehicleIdx + '_include']"
                             [id]="'vehicle_' + vehicleIdx + '_include_2'" [disabled]="isFormDisabled(2)">
                      <label class="form-check-label" [for]="'vehicle_' + vehicleIdx + '_include_2'">Include</label>
                    </div>
                  </td>
                  <td>
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox" [(ngModel)]="sectionCheckboxes[3]['vehicle_' + vehicleIdx + '_include']"
                             [id]="'vehicle_' + vehicleIdx + '_include_3'" [disabled]="isFormDisabled(3)">
                      <label class="form-check-label" [for]="'vehicle_' + vehicleIdx + '_include_3'">Include</label>
                    </div>
                  </td>
                </tr>
                <ng-container *ngFor="let field of vehicleDetailFields">
                  <tr>
                    <td><strong>{{ field.label }}</strong></td>
                    <td>{{ getOriginalValue('vehicle_' + vehicleIdx + '_' + field.key) }}</td>
                    <td>
                      <input type="text" class="form-control form-control-sm"
                             [formControl]="getFormControl(blForm1, 'vehicle_' + vehicleIdx + '_' + field.key)"
                             [disabled]="isFormDisabled(1)">
                    </td>
                    <td>
                      <input type="text" class="form-control form-control-sm"
                             [formControl]="getFormControl(blForm2, 'vehicle_' + vehicleIdx + '_' + field.key)"
                             [disabled]="isFormDisabled(2)">
                    </td>
                    <td>
                      <input type="text" class="form-control form-control-sm"
                             [formControl]="getFormControl(blForm3, 'vehicle_' + vehicleIdx + '_' + field.key)"
                             [disabled]="isFormDisabled(3)">
                    </td>
                  </tr>
                </ng-container>
              </ng-container>

              <!-- Shipping Details Section Header -->
              <tr class="bg-light-primary">
                <td><strong>Shipping Details</strong></td>
                <td>-</td>
                <td>
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" [(ngModel)]="sectionCheckboxes[1].shipping_details"
                           id="shipping_details_1" [disabled]="isFormDisabled(1)">
                    <label class="form-check-label" for="shipping_details_1">Include</label>
                  </div>
                </td>
                <td>
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" [(ngModel)]="sectionCheckboxes[2].shipping_details"
                           id="shipping_details_2" [disabled]="isFormDisabled(2)">
                    <label class="form-check-label" for="shipping_details_2">Include</label>
                  </div>
                </td>
                <td>
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" [(ngModel)]="sectionCheckboxes[3].shipping_details"
                           id="shipping_details_3" [disabled]="isFormDisabled(3)">
                    <label class="form-check-label" for="shipping_details_3">Include</label>
                  </div>
                </td>
              </tr>
              <ng-container *ngFor="let field of shippingFields">
                <tr>
                  <td><strong>{{ field.label }}</strong></td>
                  <td>{{ getOriginalValue(field.key) }}</td>
                  <td>
                    <input type="text" class="form-control form-control-sm"
                           [formControl]="getFormControl(blForm1, field.key)"
                           [disabled]="isFormDisabled(1)">
                  </td>
                  <td>
                    <input type="text" class="form-control form-control-sm"
                           [formControl]="getFormControl(blForm2, field.key)"
                           [disabled]="isFormDisabled(2)">
                  </td>
                  <td>
                    <input type="text" class="form-control form-control-sm"
                           [formControl]="getFormControl(blForm3, field.key)"
                           [disabled]="isFormDisabled(3)">
                  </td>
                </tr>
              </ng-container>

              <!-- Save Buttons Row -->
              <tr class="bg-light">
                <td><strong>Actions</strong></td>
                <td>-</td>
                <td>
                  <button type="button" class="btn btn-sm btn-primary"
                          (click)="saveAmendment(1)" [disabled]="isLoading1 || isFormDisabled(1)">
                    <span *ngIf="isLoading1" class="spinner-border spinner-border-sm me-1"></span>
                    Save Amendment 1
                  </button>
                </td>
                <td>
                  <button type="button" class="btn btn-sm btn-primary"
                          (click)="saveAmendment(2)" [disabled]="isLoading2 || isFormDisabled(2)">
                    <span *ngIf="isLoading2" class="spinner-border spinner-border-sm me-1"></span>
                    Save Amendment 2
                  </button>
                </td>
                <td>
                  <button type="button" class="btn btn-sm btn-primary"
                          (click)="saveAmendment(3)" [disabled]="isLoading3 || isFormDisabled(3)">
                    <span *ngIf="isLoading3" class="spinner-border spinner-border-sm me-1"></span>
                    Save Amendment 3
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-light" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>
